/**
 * Review Dashboard (in-sidebar)
 * Full-conversation review workspace: pick a conversation, walk its thread, and
 * leave per-response feedback. Shares the workspace with the Client Feedback page.
 */

import { SentinelReviewWorkspace } from "@/modules/sentinel/sentinel-review-workspace";

export default function SentinelConversations() {
  return <SentinelReviewWorkspace listTitle="Review Dashboard" />;
}
